<template>
    <EvoKeyboard :key="step._field_name" :name="step._field_name" :field="step._field" :step="step"></EvoKeyboard>
</template>

<script>
import mixin from "./travel_step_mixin";
import EvoKeyboard from "../fields/EvoKeyboard";

export default {
    components: {EvoKeyboard},
    mixins: [mixin],
}
</script>

<style scoped>

</style>
